<style scoped>

#fake {
    position: absolute;
    top: -15000px;
}

</style>

<template>

<v-container grid-list-xs class="mb-5">
    <v-flex xs12 sm10 md8 lg6 class="mx-auto">
        <v-card color="transparent" flat class="px-2 text-xs-center" v-if="content">
            <v-card-title primary-title class="py-0">
              <h1 class="display-1 mx-auto">{{content.title}}</h1>
            </v-card-title>
            <v-expand-transition>
              <v-alert :value="error" color="error" icon="warning" outline class="mb-3">
                {{error}}
              </v-alert>
            </v-expand-transition>
            <v-form @submit.prevent="submit()" ref="form">
                <input type="password" id="fake" />
                <v-text-field v-model="form.name" :label="content.name" :rules="[rules.name]"></v-text-field>
                <v-text-field type="text" v-model="form.switch_id" :label="content.uid" :rules="[rules.switch]" mask="NNNNNNNNNNNNNNNN"></v-text-field>
                <span class="red--text" v-if="errors && errors.switch">{{content.validation.uid}}</span>
                <v-text-field :type="showp ? 'text' : 'password'" v-model="form.password" :label="content.password" :rules="[rules.password]" :append-icon="showp ? 'visibility' : 'visibility_off'" @click:append="showp = !showp"></v-text-field>
                <v-layout row wrap>
                  <v-flex d-flex shrink align-center align-content-center>
                    <span class="title">{{content.role}}:</span>
                  </v-flex>
                  <v-flex shrink>
                    <v-radio-group v-model="form.role" row>
                      <v-radio color="primary" :label="content.controller" value="1"></v-radio>
                      <v-radio color="primary" :label="content.sensors" value="0"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-btn color="success" :loading="loading" block type="submit" dark class="mt-3">{{content.submit}}</v-btn>
            </v-form>
        </v-card>
    </v-flex>
</v-container>

</template>

<script>

export default {
    data() {
            return {
                form: {
                    name: null,
                    switch_id: null,
                    password: null,
                    role: '1',
                },
                rules: {
                  name: v => (!v || v.length <= 25) || this.content.validation.name,
                  switch: v => !!v || this.content.validation.uid,
                  password: v => (v && v.length > 7) || this.content.validation.password
                },
                showp: false,
                locale: null,
                content: {},
                errors: {},
                error: null,
                loading: false,
            };
        },
        created() {
            this.locale = Lang.get();
            this.setLang();
        },
        methods: {
            submit() {
                    if (this.$refs.form.validate()) {
                      this.loading = true;
                        axios.post(
                          `/api/switch/new`,
                           this.form
                         ).then(res => {
                          this.$store.dispatch('devices/setDevice', res.data.device);
                          this.loading = false;
                          this.$store.dispatch('devices/fetchDevices');
                          this.$router.push("/");
                        })
                        .catch(err => {
                          this.loading = false;
                          if (err.response.data.message === 'exists') {
                            this.error = this.content.exists;
                          } else {
                            this.error = this.content.error;
                          }
                          this.loading = false;
                        });
                    }
                },
                setLang() {
                    if (this.locale == "en") {
                        this.content = {
                            title: "Add A New Unit",
                            name: "Unit's Name (optional)",
                            uid: "Unit's ID",
                            password: "password",
                            submit: "Create",
                            role: 'Unit\'s Role',
                            controller: 'Controller',
                            sensors: 'Sensors',
                            validation: {
                              name: "The name can't be longer than 25 characters",
                              uid: "Unit's ID is required",
                              password: "Password must be at least 8 characters"
                            },
                            error: "Unit's ID or Password are incorrect",
                            exists: "You have already registered this unit",
                        };
                    } else if (this.locale == "he") {
                        this.content = {
                            title: 'הוסף יחידה חדשה',
                            name: 'שם יחידה (אפשרי)',
                            uid: "מספר היחידה",
                            password: "סיסמא",
                            submit: "שלח",
                            role: 'תפקיד היחידה',
                            controller: 'בקר',
                            sensors: 'חיישנים',
                            validation: {
                              name: "שם היחידה לא יכול להיות ארוך 25 תווים",
                              uid: "חובה להזין את מספר היחידה",
                              password: "הסיסמא חייבת להיות לפחות 8 תווים"
                            },
                            error: 'מספר היחידה או הסיסמא אינם נכונים',
                            exists: "היחידה הזאת כבר רשומה אצלך",
                        };
                    }
                }
        }
};

</script>
